<template>
  <div style="width: 100%;margin-bottom: 10px;border: 1px solid rgba(41, 155, 255, .2);padding: 5px;">
    <el-row>
      <el-col :span="20">
        <el-row>
          <el-col :lg="4" :md="5" :sm="8" :xl="4" :xs="8" style="margin-top: 10px;">告警产生</el-col>
          <el-col :lg="20" :md="19" :sm="16" :xl="20" :xs="16">
            <div style="float: left; margin-top: 5px;">
              <el-input size="mini" style="width: 50px;" v-model="actionForm.startTime"></el-input>
              <span>分钟后,</span>
            </div>
            <div style="float: left; margin-top: 5px;">
              <span>共持续</span>
              <el-input size="mini" style="width: 50px;" v-model="actionForm.time"></el-input>
              <span>次,</span>
            </div>
            <div style="float: left; margin-top: 5px;">
              <span>每次间隔</span>
              <el-input size="mini" style="width: 50px;" v-model="actionForm.intervalTime"></el-input>
              <span>分钟</span>
            </div>
          </el-col>
        </el-row>
        <el-row class="margin-top-10">
          <el-col :lg="4" :md="5" :sm="8" :xl="4" :xs="8" style="margin-top: 5px;">通知人</el-col>
          <el-col :lg="20" :md="19" :sm="16" :xl="20" :xs="16">
            <el-select
              @change="changeAccount"
              multiple
              placeholder="请选择人员"
              size="mini"
              style="width: 100%;"
              v-model="actionForm.noticeAccountIds">
              <el-option
                :key="item.id"
                :label="item.nickname"
                  :value="item.id"
                  v-for="item in accountList">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="margin-top-10">
          <el-col :lg="4" :md="5" :sm="8" :xl="4" :xs="8" style="margin-top: 5px;">通知方式</el-col>
          <el-col :lg="20" :md="19" :sm="16" :xl="20" :xs="16">
            <el-select
              @change="changeNotifyType"
              multiple
              placeholder="请选择通知方式"
              size="mini"
              style="width: 100%;"
              v-model="actionForm.notifyTypeCodes">
              <el-option
                :key="index"
                :label="item.name"
                  :value="item.code"
                  v-for="(item,index) in notifyList">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4" style="line-height: 35px;text-align: center">
        <el-button @touchstart="add" @click="add" size="mini" style="color: #07E6F8" v-if="index===0"> +</el-button>
        <el-button @touchstart="deleteList" @click="deleteList" size="mini" style="color: red" v-if="index!==0"> -</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import {getSystematicByParentCodes} from "@/network/systematic";

export default {
  name: "StrategyDetail",
  props: {
    index: {
      type: Number,
      required: true
    },
    alarmUpgradeAction: {
      type: Array,
      default: () => []
    },
    accountList: {
      type: Array,
      default: () => []
    },
  },
  watch: {
    alarmUpgradeAction: {
      handler(newV) {
        if (newV.length !== 0) {
          this.actionForm = {...newV[this.index]}
        }
      },
      deep: true
    },
    actionForm: {
      handler(newV) {
        this.$emit('uploadData', {index: this.index, data: newV})
      },
      deep: true
    },
  },
  data() {
    return {
      actionForm: {},
      notifyList: []
    }
  },
  created() {
    this.getByParentCodes();
    this.actionForm = this.alarmUpgradeAction[this.index]
  },
  methods: {
    add() {
      this.$emit('add')
    },
    deleteList() {
      this.$emit('deleteIndex', this.index)
    },
    //获取通知方式
    getByParentCodes() {
      this.notifyList = []
      getSystematicByParentCodes("notification_type").then(res => {
        this.notifyList = res.data.filter(item => item.code !== "voiceWarningNotification");
      })
    },
    //通知人下拉框选择
    changeAccount(ids) {
      this.actionForm.accountNames = []
      ids.forEach(id => {
        const item = this.accountList.filter(i => i.id === id)[0]
        this.actionForm.accountNames.push(item.nickname)
      })
    },
    //通知方式下拉框选择
    changeNotifyType(codes) {
      this.actionForm.notifyNames = []
      codes.forEach(code => {
        const item = this.notifyList.filter(i => i.code === code)[0]
        this.actionForm.notifyNames.push(item.name)
      })
    },
  }
}
</script>

<style scoped>

</style>
